export var MAX_PAGES_TO_SHOW_ARROWS = 7;
